module.exports = __webpack_public_path__ + "static/media/demonstration.b3a62874.jpeg";